module.exports = __webpack_public_path__ + "media/images/srgssr_logo-e9c5e633ad8e882d1901b0918616cfa3.svg";